import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const adminSetEmployee = info =>
  call(websocketFetch, 'admin_set_employee', info);
